import React from 'react'

const Opportunities = () => {
    return (
        <>

            <section className="counter-section fix bg-cover-2" style={{ backgroundImage: 'url(assets/img/counter-bg.png)', marginTop:"-70px" }}>
                <div className="container">
                    <div className="counter-wrapper">
                        <div className="counter-item wow fadeInUp" data-wow-delay=".2s">
                            <div className="icon">
                                <img src="assets/img/icon/c-1.svg" alt="img" />
                            </div>
                            <div className="content">
                                <h2><span className="count">18</span>+</h2>
                                <p> Award</p>
                            </div>
                        </div>
                        <div className="counter-item wow fadeInUp" data-wow-delay=".4s">
                            <div className="icon">
                                <img src="assets/img/icon/c-2.svg" alt="img" />
                            </div>
                            <div className="content">
                                <h2><span className="count">12</span>+</h2>
                                <p>Class Room</p>
                            </div>
                        </div>
                        <div className="counter-item wow fadeInUp" data-wow-delay=".6s">
                            <div className="icon">
                                <img src="assets/img/icon/c-3.svg" alt="img" />
                            </div>
                            <div className="content">
                                <h2><span className="count">955</span>+</h2>
                                <p>Students</p>
                            </div>
                        </div>
                        <div className="counter-item style-2 wow fadeInUp" data-wow-delay=".8s">
                            <div className="icon">
                                <img src="assets/img/icon/c-4.svg" alt="img" />
                            </div>
                            <div className="content">
                                <h2><span className="count">25</span>+</h2>
                                <p>Year of Experience</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default Opportunities